import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-casestudies-container',
  imports: [CommonModule,RouterModule],
  standalone: true,
  templateUrl: './casestudies-container.component.html',
  styleUrl: './casestudies-container.component.scss'
})
export class CasestudiesContainerComponent {

}
